module.exports = __webpack_public_path__ + "static/img/Jack_Riewoldt_desktop.33e93a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Riewoldt_desktop.jpg
// module id = jGmi
// module chunks = 0